import * as React from "react";
// PublicRoute.jsx
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import LoadingState from "../states/LoadingState";

// PublicRoute.jsx - Use for login/signup routes
export const PublicRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading spinner while checking auth status
  if (isLoading) {
    return <LoadingState />;
  }

  // Redirect to dashboard if already authenticated
  return isAuthenticated ? <Navigate to="/Product_All" replace /> : <Outlet />;
};
